import { render, staticRenderFns } from "./ShowCurrentDiscussion.vue?vue&type=template&id=5037a021&"
import script from "./ShowCurrentDiscussion.vue?vue&type=script&lang=js&"
export * from "./ShowCurrentDiscussion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports